import React, { useState } from 'react';
import { useLang } from '../contexts/LanguageContext';
import { useSiteConfig } from '../contexts/SiteConfigContext';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

const Gallery = ({ hideHeader = false }) => {
  const { lang } = useLang();
  const { config } = useSiteConfig();
  const colors = config.identity?.colors || {};
  const items = (config.gallery || []).filter((g) => g.visible !== false);
  const [openIdx, setOpenIdx] = useState(null);

  const close = () => setOpenIdx(null);
  const next = () => setOpenIdx((i) => (i + 1) % items.length);
  const prev = () => setOpenIdx((i) => (i - 1 + items.length) % items.length);

  const tagText = lang === 'de' ? 'Galerie' : lang === 'ar' ? 'المعرض' : 'Gallery';
  const titleText =
    lang === 'de' ? 'Einblicke in unsere Arbeit'
    : lang === 'ar' ? 'لمحات من أعمالنا'
    : 'Insights into Our Work';

  return (
    <section id="gallery" className="relative py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {!hideHeader && (
          <div className="text-center mb-16">
            <p
              className="text-xs md:text-sm mb-4 tracking-[0.3em] uppercase font-medium"
              style={{ color: colors.accent || '#b54e7d' }}
            >
              {tagText}
            </p>
            <h2
              className="font-display mb-4"
              style={{
                color: colors.text_dark || '#5a1d3b',
                fontSize: 'clamp(1.875rem, 3vw, 2.75rem)',
                fontWeight: 500,
              }}
            >
              {titleText}
            </h2>
            <div
              className="w-16 h-px mx-auto mt-8 opacity-40"
              style={{ backgroundColor: colors.primary || '#c4477a' }}
            />
          </div>
        )}

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-5">
          {items.map((g, i) => (
            <button
              key={g.id}
              onClick={() => setOpenIdx(i)}
              className="group relative aspect-square overflow-hidden rounded-2xl"
            >
              <img
                src={g.image}
                alt={g.caption || ''}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-[#5a1d3b]/0 group-hover:bg-[#5a1d3b]/15 transition-colors" />
            </button>
          ))}
        </div>
      </div>

      {openIdx !== null && items[openIdx] && (
        <div
          className="fixed inset-0 z-[60] bg-black/85 backdrop-blur-sm flex items-center justify-center p-4"
          onClick={close}
        >
          <button className="absolute top-5 right-5 text-white p-2 hover:bg-white/10 rounded-full" onClick={close}>
            <X className="w-7 h-7" />
          </button>
          <button
            className="absolute left-5 text-white p-2 hover:bg-white/10 rounded-full"
            onClick={(e) => { e.stopPropagation(); prev(); }}
          >
            <ChevronLeft className="w-8 h-8" />
          </button>
          <img
            src={items[openIdx].image}
            alt=""
            className="max-w-[90vw] max-h-[85vh] object-contain rounded-xl"
            onClick={(e) => e.stopPropagation()}
          />
          <button
            className="absolute right-5 text-white p-2 hover:bg-white/10 rounded-full"
            onClick={(e) => { e.stopPropagation(); next(); }}
          >
            <ChevronRight className="w-8 h-8" />
          </button>
        </div>
      )}
    </section>
  );
};

export default Gallery;
